import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../_metronic/_partials/controls";
import CoreCustomTable from "./component/CoreCustomTable";
import { ClearFiltersButton, PageSizeSelect, SearchField } from "./component/TableFilters";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURL } from "../service/API.js";
import Swal from "sweetalert2";
import axios from "axios";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { roleCheck } from '../service/role';
import { hasAction } from '../service/permissions';
import { apiMessage } from '../service/apiError';

export const Role = () => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const _allData = [];
    const [settingPrinterZone, setSettingPrinterZoneData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [listError, setListError] = useState('');
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [_totalSize, setTotalSize] = useState(100);
    suhbeader.setTitle(intl.formatMessage({ id: "113175" ,defaultMessage:"Role Management"}));
    const { authToken } = useSelector((state) => state.auth);
    const [campaigns_id_headder, setCampaigns_id_headder] = useState();
    const [roleList, setRoleList] = useState([]);

    const history = useHistory();
    useEffect(() => {
        localStorage.removeItem('edit')        
        checkAuth();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAuth =async()=> {
        const data = await roleCheck('ROLE')
        setRoleList(data)
        console.log(data)
        if (!hasAction(data, 'VIEW')) {
          history.push('/auth/login')
          return
        }
        let value = 1
        if(localStorage.getItem("pagePrinterZone") != null){
            value = localStorage.getItem("pagePrinterZone")
        }
        let campaigns_id_headders = localStorage.getItem("campaigns_id_headder")
        setCampaigns_id_headder(campaigns_id_headders);
        getList(value, 10, search, campaigns_id_headders);

      }

    const getList = async (page, limit, search, campaigns_id_headders) => {
        setPage(page);
        setIsLoading(true);
        setListError('');
        axios({
            method: "get",
            url: `${baseURL}/api/v1/role?page=${page}&limit=${limit}${search !== undefined && search !== "" ? "&search=" + search : ""
                }`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        }).then((res) => {
            if (res.message) {
                history.push("/logout");
            } else {
                console.log(res.data.data)
                
            }

            var totalpage = Math.ceil(res.data.total / res.data.limit);
            setTotalPage(totalpage);
            setTotalSize(res.data.total);
            setLimit(res.data.limit);
            setSettingPrinterZoneData(res.data.data);
            setListError('');
        }).catch((err) => {
            setSettingPrinterZoneData([]);
            setListError(apiMessage(err, 'โหลดรายการ Role ไม่สำเร็จ'));
        }).finally(() => setIsLoading(false));
    };

    const columns = [
        {
            dataField: "id",
            text: "ID",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },

        {
            dataField: "role",
            text: "Role",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },


        {
            dataField: "created_at",
            text: 'created at',
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "update_at",
            text: 'update at',
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        // {
        //     dataField: "created_at",
        //     text: "Create Date",
        //     sort: true,
        //     sortCaret: sortCaret,
        //     headerSortingClasses,
        // },
        {
            text: intl.formatMessage({ id: "107008",defaultMessage:"Action" }),
            dataField: "id",
            formatter: (id, row, rowIndex) => {
                return (
                    <div>
                        {hasAction(roleList, 'EDIT') &&  <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => editItem({ row, rowIndex })}
                        >
                            {intl.formatMessage({ id: "104012",defaultMessage:"edit" })}
                        </button>}
                        {hasAction(roleList, 'DELETE') &&  <button
                            type="button"
                            className="btn btn-primary ml-3"
                            onClick={() => deleteItem({ row, rowIndex })}
                        >
                            {intl.formatMessage({ id: "107011",defaultMessage:"delete" })}
                        </button>}
                    </div>
                    
                );
            },
        },
    ];
    const editItem = (data) => {
        console.log(data)
        history.push("/EditRole", data);
    };

    const deleteItem = (data) => {
        let token = localStorage.getItem("Token");
        Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover this template !",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.value) {
                axios.delete(`${baseURL}/api/v1/role/${data.row.id}`, {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }).then((res) => {
                    Swal.fire("Deleted!", "Your template has been deleted.", "success");
                    getList(1, limit, search, campaigns_id_headder);
                }).catch((err) => {
                    Swal.fire(
                        "Deleted!",
                        "Your template has been fail to deleted.",
                        "error"
                    );
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelled", "Your template is safe :)", "error");
            }
        });
    };
    // Was useState() — an undefined value makes a controlled field uncontrolled,
    // and the clear button has nothing to switch on.
    const [search, setSearch] = useState('');
    const handleSearch = () => {
        setPage(1);
        getList(1, limit, search, campaigns_id_headder);
    };

    // Clearing has to re-fetch, not just empty the box. Leaving the previous results
    // under an empty search field is the state operators read as "no more matches".
    const handleClearFilters = () => {
        setSearch('');
        setPage(1);
        getList(1, limit, '', campaigns_id_headder);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        localStorage.setItem("pagePrinterZone", value)
        getList(value, limit, search, campaigns_id_headder);
    };

    const handlePageSizeChange = (event) => {
    setPage(1);
        setLimit(event.target.value);
        getList(1, event.target.value, search, campaigns_id_headder);
    };

    return (
        <Card>
            <CardHeader title={intl.formatMessage({ id: "113175",defaultMessage:"Role Management" })}>
                <CardHeaderToolbar>
                    {hasAction(roleList, 'CREATE') && <Link to="/CreateRole">
                        <button type="button" className="btn btn-primary">
                            {intl.formatMessage({ id: "107009",defaultMessage:"Create" })}
                        </button>
                    </Link>}
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <div className="row form-inline mb-2">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                        <div className="form-group">
                            <SearchField
                                placeholder={intl.formatMessage({ id: "107002" ,defaultMessage:"Text Search"})}
                                value={search}
                                onChange={setSearch}
                                onSearch={handleSearch}
                            />
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                        <div className="form-group">
                            <button
                                type="button"
                                id="button"
                                className="btn btn-primary"
                                style={{ width: "100%" }}
                                onClick={() => handleSearch()}
                            >
                                {intl.formatMessage({ id: "107003",defaultMessage:"search" })}
              </button>
                        </div>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="form-group">
                            <ClearFiltersButton show={Boolean(search)} onClear={handleClearFilters} />
                        </div>
                    </div>
                </div>

                <CoreCustomTable
                    data={settingPrinterZone === undefined ? [] : settingPrinterZone}
                    columns={columns}
                    loading={isLoading}
                    error={listError}
                >
                    <PleaseWaitMessage entities={settingPrinterZone} />
                    <NoRecordsFoundMessage entities={settingPrinterZone} />
                </CoreCustomTable>
                <div className=" col-lg-12">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mt-3">
                                <PageSizeSelect
                                    label={intl.formatMessage({ id: "107032",defaultMessage:"Item per page" })}
                                    value={limit}
                                    onChange={handlePageSizeChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <Pagination2
                                className="mt-3 "
                                count={totalPage}
                                page={localStorage.getItem("pagePrinterZone") != null ? Number(localStorage.getItem("pagePrinterZone")) : page}
                                siblingCount={1}
                                boundaryCount={1}
                                variant="outlined"
                                shape="rounded"
                                onChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};
